import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../assets/styles/colors';
import commons from '../../../assets/styles/commons';

const useStyles = makeStyles(theme => ({
  label: {
    fontSize: commons.fontSize.large,
    fontFamily: commons.fontFamily,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  buttonStyle: {
    borderRadius: 4,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    borderStyle: 'solid',
    padding: 16,

    '&:disabled': {
      backgroundColor: colors.secondary.brightBlue,
      color: colors.secondary.deepSky,
      borderWidth: 2,
    },
  },
  borderWidth2: { borderWidth: 2 },
  colorWhite: { color: colors.base },
  loadingStack: {
    position: 'absolute',
    zIndex: 1,
    alignSelf: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
